import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const addSettlementReportFormatReq = (mid: string, addObject: any, tokens: any, isSmid: boolean) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.addSettlementReportFormat,
    method: 'POST',
    config: sitConfig(tokens),
    // headers: {
    //   'Content-Type': 'application/json',
    //   Authorization: userAccessToken,
    // },
    body: {
      inputFilter: {
        merchantId: mid,
        isSMID: isSmid ? 'Y' : 'N',
        ...addObject,
      },
    }, //TODO: change once we get api specs
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { addSettlementReportFormatReq }
